<div class="d-flex flex-column w-100">
  <!-- Header -->
  <div class="w-100 d-flex flex-row flex-nowrap align-items-start gap-2 mb-3">
    <div class="w-100 d-flex flex-column gap-2">
      <h4 class="fw-bold header-font mb-0 d-flex flex-row align-items-center">
        <app-custom-icon
          class="color-primary me-2"
          default="bi-award"
          customIconKey="rewards_navigation_icon"
          altText="Rewards"></app-custom-icon>
        {{ section?.section_title || 'Rewards' }}
      </h4>
    </div>
    <!-- Points Balance -->
    <div class="ms-auto">
      <ng-container *ngIf="isDashboard; else viewAll">
        <ng-container *ngIf="displayBalances?.rewardAmounts && displayBalances?.rewardAmounts.length">
        <button class="pill-btn-default pill-btn-sm text-nowrap" (click)="openRewardsBalances.emit()">View Expirations</button>
      </ng-container>
      </ng-container>
      <ng-template #viewAll>
        <button class="pill-btn-default pill-btn-sm text-nowrap" [routerLink]="rewardsRoute">View All Rewards</button>
      </ng-template>
    </div>
  </div>

  <div class="mb-3" *ngIf="displayBalances?.points || displayBalances?.pointExpirations?.points_expiry.length">
    <ng-container *ngIf="displayBalances?.points && displayBalances?.points != null">
      You have <span class="font-bold">{{ displayBalances.points }} {{ displayBalances?.pointsUnit ?? 'Points' }}</span
      >
    </ng-container>
    <ng-container *ngIf="displayBalances?.points && displayBalances?.pointExpirations?.points_expiry.length">
      &nbsp;|&nbsp;
    </ng-container>
    <ng-container *ngIf="displayBalances?.pointExpirations?.points_expiry.length">
      {{ displayBalances?.pointExpirations?.points_expiry[0]?.expiring_points }} points are expiring on {{displayBalances?.pointExpirations?.points_expiry[0]?.expiring_at}}
    </ng-container>
  </div>

  <!-- Segmented View -->
  <ng-container *ngIf="segmentedRewards$ | async as segmented">
    <!-- If there are rewards at all -->
    <ng-container *ngIf="segmented.rawRewards.length > 0 || segmented.hasUnlockables; else noRewards">
      <!-- Segmented view if there are unlockables -->
      <ng-container *ngIf="segmented.hasUnlockables; else nonSegmentedRewards">
        <ion-segment [value]="selectedSegment" (ionChange)="onSegmentChange($event)" mode="ios" class="mb-3 d-flex">
          <ion-segment-button value="rewards" class="grow-1 basis-0 d-flex">
            <ion-label class="d-flex align-items-center relative w-full justify-start align-self-start">
              <ion-text class="text-capitalize me-2">Rewards</ion-text>
              <ion-badge slot="end" color="secondary" class="segment-badge">{{ segmented.rewards.length }}</ion-badge>
            </ion-label>
          </ion-segment-button>
          <ion-segment-button value="unlockables" class="grow-1 basis-0 d-flex">
            <ion-label class="d-flex align-items-center relative w-full justify-start align-self-start">
              <ion-text class="text-capitalize me-2">Reward Store</ion-text>
              <ion-badge slot="end" color="secondary" class="segment-badge">{{ segmented.unlockables.length }}</ion-badge>
            </ion-label>
          </ion-segment-button>
        </ion-segment>

        <!-- Rewards Segment -->
        <ng-container *ngIf="selectedSegment === 'rewards'">
          <ng-container *ngIf="(segmented.rewards | removeCouponRewards).length > 0; else emptyRewards">
            <div class="reward-cards-container">
              <app-reward-card
                *ngFor="let reward of segmented.rewards | removeCouponRewards; trackBy: rewardTrackBy"
                [reward]="reward"
                [isStaged]="stagedReward && stagedReward.externalRef === reward.externalRef"
                (clickedRedeem)="redeemReward.emit(reward)"
                (clickedRedeemInStore)="redeemInStoreReward.emit(reward)"
                (clickedRemove)="removeReward.emit(reward)"
                [currencyCode]="currencyCode"
                [availablePoints]="displayBalances?.points">
              </app-reward-card>
            </div>
          </ng-container>
        </ng-container>

        <!-- Unlockables Segment -->
        <ng-container *ngIf="selectedSegment === 'unlockables'">
          <ng-container *ngIf="(segmented.unlockables | removeCouponRewards).length > 0; else emptyUnlockables">
            <div class="reward-cards-container">
              <app-reward-card
                *ngFor="let reward of segmented.unlockables | removeCouponRewards; trackBy: rewardTrackBy"
                [reward]="reward"
                [isStaged]="stagedReward && stagedReward.externalRef === reward.externalRef"
                (clickedRedeem)="redeemReward.emit(reward)"
                (clickedRedeemInStore)="redeemInStoreReward.emit(reward)"
                (clickedRemove)="removeReward.emit(reward)"
                [currencyCode]="currencyCode"
                [availablePoints]="displayBalances?.points">
              </app-reward-card>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>

      <!-- Non-segmented view (if no unlockables) -->
      <ng-template #nonSegmentedRewards>
        <div class="reward-cards-container">
          <app-reward-card
            *ngFor="let reward of segmented.rawRewards | removeCouponRewards; trackBy: rewardTrackBy"
            [reward]="reward"
            [isStaged]="stagedReward && stagedReward.externalRef === reward.externalRef"
            (clickedRedeem)="redeemReward.emit(reward)"
            (clickedRedeemInStore)="redeemInStoreReward.emit(reward)"
            (clickedRemove)="removeReward.emit(reward)"
            [currencyCode]="currencyCode"
            [availablePoints]="displayBalances?.points">
          </app-reward-card>
        </div>
      </ng-template>
    </ng-container>
  </ng-container>

  <!-- Loading Skeletons Template -->
  <ng-template #rewardsLoading>
    <ion-list class="w-100 reward-cards-container">
      <ng-container *ngFor="let item of [].constructor(6)">
        <app-skeleton-card class="w-100" [productCard]="true" [description]="false"></app-skeleton-card>
      </ng-container>
    </ion-list>
  </ng-template>

  <!-- No Rewards Template -->
  <ng-template #noRewards>
    <div class="d-flex flex-column gap-3 justify-content-center align-items-center p-3">
      <app-custom-icon
        class="color-primary display-3"
        default="bi-award"
        customIconKey="rewards_navigation_icon"
        altText="Rewards"></app-custom-icon>
      <div class="text-center d-flex flex-column">
        <h5 class="fw-bold">You currently have no rewards.</h5>
        <div>Order now to start earning rewards!</div>
      </div>
      <button class="de-primary-link w-100" style="max-width: 264px" [routerLink]="locationsRoute">Order Now</button>
    </div>
  </ng-template>

  <!-- Empty Unlockables Template -->
  <ng-template #emptyUnlockables>
    <div class="d-flex flex-column gap-3 justify-content-center align-items-center p-3">
      <app-custom-icon
        class="color-primary display-3"
        default="bi-award"
        customIconKey="rewards_navigation_icon"
        altText="Rewards"></app-custom-icon>
      <div class="text-center d-flex flex-column">
        <h5 class="fw-bold">No Current Unlockables</h5>
        <div>
          Start earning points by placing orders. Spend your points to unlock rewards.
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Empty Rewards Template -->
  <ng-template #emptyRewards>
    <div class="d-flex flex-column gap-3 justify-content-center align-items-center p-3">
      <app-custom-icon
        class="color-primary display-3"
        default="bi-award"
        customIconKey="rewards_navigation_icon"
        altText="Rewards"></app-custom-icon>
      <div class="text-center d-flex flex-column">
        <h5 class="fw-bold">No Current Rewards</h5>
        <div>
          Order now to start earning rewards!
        </div>
      </div>
      <button class="de-primary-link w-100" style="max-width: 264px" [routerLink]="locationsRoute">Order Now</button>
    </div>
  </ng-template>
</div>
